import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/sign-up-login/components/AuthForm.tsx");
